<template>
    <div class='com-calendar-wrap'>
        <button class='prev-day' @click='onClickBtnPrev'></button>
        <single-calendar :show-date-format='showDateFormat' :start-date='date' @update='onUpdateDate'></single-calendar>
        <button class='next-day' @click='onClickBtnNext'></button>
    </div>
</template>

<script>
/*
입력 모델 : selectedDate, interval
callback : updateDate
 */
import moment from 'moment';
import { Utils } from '@/assets/js/utils';

export default {
    name: 'ScheduleDateSelector',
    props: {
        selectedDate: String,
        interval: {
            type: [Number, String],
            default: 1,
        },
        dateFormat: {
            type: String,
            default: 'YYYY-MM-DD',
        },
        callbackUpdateDate: Function,
    },
    data() {
        return {
            date: '',
            showDateFormat: 'YYYY-MM-DD(dd)',
        };
    },
    mounted() {
        this.date = this.selectedDate;
        // this.date = moment(this.selectedDate).locale('ko').format('YYYY-MM-DD(dd)');
    },
    methods: {
        onClickBtnPrev() {
            // let d = moment(this.date, this.dateFormat).subtract(this.interval, 'days').format(this.dateFormat);
            const d = moment(this.date, this.dateFormat).subtract(this.interval, 'days').format(this.dateFormat);
            this.onUpdateDate(d);
            // console.log('moment',moment().locale('ko').format('YYYY-MM-DD(dd)'))
        },
        onClickBtnNext() {
            // let d = moment(this.date, this.dateFormat).add(this.interval, 'days').format(this.dateFormat);
            const d = moment(this.date, this.dateFormat).add(this.interval, 'days').format(this.dateFormat);
            this.onUpdateDate(d);
        },
        onUpdateDate(d) {
            if (this.date !== d && !Utils.isEmpty(this.callbackUpdateDate)) {
                this.date = d;
                // this.date = moment(d).locale('ko').format('YYYY-MM-DD(dd)');
                this.callbackUpdateDate(d);
            }
        },
    },
};
</script>

<style scoped>

</style>
